<div *cbWaitFor="lotSpec" class="cb-margin start-center flex-row">
    <cb-display-value-new
        class="flex"
        label="Lot Spec Version"
        [value]="lotSpecVersion"
    ></cb-display-value-new>
    <button mat-raised-button color="primary" (click)="generateReport()">
        <mat-icon>insert_drive_file</mat-icon>
        &nbsp;Generate Report
    </button>
    <button
        class="cb-margin-left"
        mat-raised-button
        [disabled]="!hasItems"
        (click)="expandCollapseAll()"
    >
        @if (!allExpanded) {
            <span class="start-center flex-row">
                <span>Expand All&nbsp;</span>
                <mat-icon>keyboard_arrow_down</mat-icon>
            </span>
        }
        @if (allExpanded) {
            <span class="start-center flex-row">
                <span>Collapse All&nbsp;</span>
                <mat-icon>keyboard_arrow_up</mat-icon>
            </span>
        }
    </button>
</div>
<mat-accordion [multi]="true" class="accordion">
    @for (group of specGroups; track group) {
        <mat-expansion-panel
            class="panel"
            [(expanded)]="expandedPanels[group.specGroupId]"
            (expandedChange)="setAllExpanded()"
        >
            <mat-expansion-panel-header class="cb-padding-top cb-padding-bottom">
                <mat-panel-title>
                    <span class="mat-body-strong cb-margin-top">{{ group.label }}</span>
                </mat-panel-title>
                <mat-panel-description class="end-center flex-row">
                    @if (
                        expandedPanels[group.specGroupId] &&
                        canEditPricingRevisionSpecs() &&
                        showAddButton()
                    ) {
                        <button
                            style="margin: 3px"
                            color="primary"
                            mat-raised-button
                            [matMenuTriggerFor]="action"
                            (click)="$event.stopPropagation()"
                            [disabled]="!canEditPricingRevisionSpecs()"
                        >
                            Add Item
                        </button>
                        <mat-menu #action="matMenu">
                            <button mat-menu-item (click)="addLotSpecItem(group.specGroupId)">
                                <mat-icon class="cb-grey">image</mat-icon>
                                <span>&nbsp;Lot Spec Item</span>
                            </button>
                            <button mat-menu-item (click)="addLotSpecColourItem(group.specGroupId)">
                                <mat-icon class="cb-grey">format_paint</mat-icon>
                                <span>&nbsp;Colour Item</span>
                            </button>
                        </mat-menu>
                    }
                </mat-panel-description>
            </mat-expansion-panel-header>
            <cb-table [loaded]="true" [stringColumns]="columns">
                <tbody cbTableBody>
                    @for (specItem of group.items; track specItem) {
                        @if (!specItem.isColourItem) {
                            <tr>
                                <td>
                                    <div class="flex-row start-center">
                                        @if (isBundle($any(specItem.item).costType)) {
                                            <mat-icon class="cb-grey cb-help-cursor"
                                                >folder
                                            </mat-icon>
                                        }
                                        @if ($any(specItem.item).bundleId) {
                                            <mat-icon
                                                class="cb-grey cb-help-cursor"
                                                matTooltip="Is part of bundle"
                                                >attach_file</mat-icon
                                            >
                                        }
                                        @if (specItem.item.showInClientSpecification) {
                                            <mat-icon
                                                class="cb-grey cb-help-cursor"
                                                matTooltip="Included in Flyer / Create Schedule"
                                                >style</mat-icon
                                            >
                                        }
                                        @if ($any(specItem.item).showInColourYourDreams) {
                                            <mat-icon
                                                class="cb-grey cb-help-cursor"
                                                svgIcon="book-open-page-variant"
                                                matTooltip="Included in Colour Schedule"
                                            ></mat-icon>
                                        }
                                        @if ($any(specItem.item).isDescriptiveOnlyCost) {
                                            <mat-icon
                                                class="cb-grey cb-help-cursor"
                                                matTooltip="Descriptive Only"
                                                >notes</mat-icon
                                            >
                                        }
                                        @if ($any(specItem.item).hasImage) {
                                            <mat-icon class="cb-grey cb-help-cursor"
                                                >photo</mat-icon
                                            >
                                        }
                                    </div>
                                </td>
                                <cb-td-enum
                                    [value]="$any(specItem.item).costType"
                                    [enum]="COST_TYPE"
                                ></cb-td-enum>
                                <cb-td-text [value]="$any(specItem.item).productCode"></cb-td-text>
                                <td>
                                    {{
                                        $any(specItem.item).productDisplay
                                            ? $any(specItem.item).productDisplay
                                            : $any(specItem.item).productOther
                                              ? $any(specItem.item).productOther
                                              : '-'
                                    }}
                                </td>
                                <td>
                                    @if (
                                        $any(specItem.item).offeringOptions &&
                                        $any(specItem.item).offeringOptions.length > 0
                                    ) {
                                        <ul class="inline-list">
                                            @for (
                                                opt of $any(specItem.item).offeringOptions;
                                                track opt
                                            ) {
                                                <li>{{ opt.name }}</li>
                                            }
                                        </ul>
                                    }
                                    @if (
                                        !$any(specItem.item).offeringOptions ||
                                        $any(specItem.item).offeringOptions.length < 1
                                    ) {
                                        <span class="inline-list">-</span>
                                    }
                                </td>
                                <cb-td-text [value]="getQuantity($any(specItem.item))"></cb-td-text>
                                @if (
                                    $any(specItem.item).isProvisionalCost ||
                                    $any(specItem.item).isEstimatedCost
                                ) {
                                    <cb-td-currency
                                        [value]="$any(specItem.item).rate"
                                        [gstMode]="
                                            $any(specItem.item).isProvisionalCost ? 'addGst' : null
                                        "
                                    ></cb-td-currency>
                                }
                                @if (
                                    !$any(specItem.item).isProvisionalCost &&
                                    !$any(specItem.item).isEstimatedCost
                                ) {
                                    <td>-</td>
                                }
                                <cb-td-text
                                    [value]="$any(specItem.item).supplierDisplay"
                                ></cb-td-text>
                                <td cbTableStickyCol="end" cbTableShrinkCol>
                                    @if (canEditPricingRevisionSpecs()) {
                                        <button
                                            mat-icon-button
                                            [matMenuTriggerFor]="action"
                                            (click)="$event.stopPropagation()"
                                            [disabled]="!canEditPricingRevisionSpecs()"
                                        >
                                            <mat-icon class="cb-grey">more_horiz</mat-icon>
                                        </button>
                                    }
                                    <mat-menu #action="matMenu">
                                        <button
                                            mat-menu-item
                                            (click)="editLotSpecItem($any(specItem.item))"
                                        >
                                            <mat-icon class="cb-grey">mode_edit</mat-icon>
                                            <span>&nbsp;Edit Product</span>
                                        </button>
                                        <button
                                            mat-menu-item
                                            (click)="removeLotSpecItem($any(specItem.item))"
                                            [disabled]="$any(specItem).bundleId"
                                        >
                                            <mat-icon class="cb-grey">remove_circle</mat-icon>
                                            <span>&nbsp;Remove Item</span>
                                        </button>
                                    </mat-menu>
                                </td>
                            </tr>
                        } @else {
                            <tr>
                                <td>
                                    <div class="flex-row start-center">
                                        <mat-icon class="cb-grey cb-help-cursor"
                                            >format_paint</mat-icon
                                        >
                                        @if (isBundle($any(specItem.item).costType)) {
                                            <mat-icon class="cb-grey cb-help-cursor"
                                                >folder
                                            </mat-icon>
                                        }
                                        @if ($any(specItem.item).bundleId) {
                                            <mat-icon class="cb-grey cb-help-cursor"
                                                >attach_file</mat-icon
                                            >
                                        }
                                        @if (specItem.item.showInClientSpecification) {
                                            <mat-icon
                                                class="cb-grey cb-help-cursor"
                                                matTooltip="Included in Flyer / Create Schedule"
                                                >style
                                            </mat-icon>
                                        }
                                        @if ($any(specItem.item).showInColourYourDreams) {
                                            <mat-icon
                                                class="cb-grey cb-help-cursor"
                                                svgIcon="book-open-page-variant"
                                                title="Included in Colour Schedule"
                                            ></mat-icon>
                                        }
                                        @if ($any(specItem.item).isDescriptiveOnlyCost) {
                                            <mat-icon class="cb-grey cb-help-cursor"
                                                >notes</mat-icon
                                            >
                                        }
                                        @if ($any(specItem.item).hasImage) {
                                            <mat-icon class="cb-grey cb-help-cursor"
                                                >photo</mat-icon
                                            >
                                        }
                                    </div>
                                </td>
                                <td>Colour</td>
                                <cb-td-text
                                    [value]="$any(specItem.item).colourItem.code"
                                ></cb-td-text>
                                <cb-td-text
                                    [value]="$any(specItem.item).colourItem.name"
                                ></cb-td-text>
                                <td>-</td>
                                <td>-</td>
                                <td>-</td>
                                <td>-</td>
                                <td cbTableStickyCol="end" cbTableShrinkCol>
                                    @if (canEditPricingRevisionSpecs()) {
                                        <button
                                            mat-icon-button
                                            [matMenuTriggerFor]="action"
                                            (click)="$event.stopPropagation()"
                                            [disabled]="!canEditPricingRevisionSpecs()"
                                        >
                                            <mat-icon class="cb-grey">more_horiz</mat-icon>
                                        </button>
                                    }
                                    <mat-menu #action="matMenu">
                                        <button
                                            mat-menu-item
                                            (click)="editColourItem($any(specItem.item))"
                                        >
                                            <mat-icon class="cb-grey">mode_edit</mat-icon>
                                            <span>&nbsp;Edit Product</span>
                                        </button>
                                        <button
                                            mat-menu-item
                                            (click)="removeLotSpecColourItem($any(specItem.item))"
                                            [disabled]="$any(specItem).bundleId"
                                        >
                                            <mat-icon class="cb-grey">remove_circle</mat-icon>
                                            <span>&nbsp;Remove Item</span>
                                        </button>
                                    </mat-menu>
                                </td>
                            </tr>
                        }
                    }
                </tbody>
            </cb-table>
            @if (!specGroups) {
                <cb-loading-spinner class="loading-spinner"> </cb-loading-spinner>
            }
        </mat-expansion-panel>
    }
</mat-accordion>
